import { Button as ButtonAntd, Modal } from "antd";
import styled, { css } from "styled-components";

export const Button = styled(ButtonAntd)`
  &,
  &.ant-btn,
  &#learn-more-btn.ant-btn-link {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.textMasterColor};
  }
`;

export const PrivateReasonModal = styled(Modal)`
  width: 100%;
  display: flex;

  p {
    margin: 0;
    text-align: justify;
    padding-right: 30px;
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      .ant-modal-content {
        background: #303030;
      }

      p {
        color: #ffffff;
      }
    `}
`;
